/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_CloseInputs */

const en_directory_submit_enrich_close = /** @type {(inputs: Directory_Submit_Enrich_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const zh_directory_submit_enrich_close = /** @type {(inputs: Directory_Submit_Enrich_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Directory_Submit_Enrich_CloseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_close = /** @type {((inputs?: Directory_Submit_Enrich_CloseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_CloseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_close(inputs)
	return zh_directory_submit_enrich_close(inputs)
});
export { directory_submit_enrich_close as "directory.submit.enrich.close" }